<template>
  <a-layout>
    <a-tabs v-model="activeKey" style="margin-top: -4px">
      <a-tab-pane key="1" :tab="$t('tab.countingOrder')" style="margin-top: -14px">
        <counting-approve-table ref="countingApproveTable" :counting-types="countingTypes" :order-status="orderStatus" @dblclick="dblclick" @fail="fail" @success="success"/>
      </a-tab-pane>
      <a-tab-pane key="2" :tab="$t('tab.countingDetail')" forceRender style="margin-top: -14px">
        <counting-approve-detail ref="countingApproveDetail" :counting-types="countingTypes" :order-status="orderStatus"/>
      </a-tab-pane>
      <a-space slot="tabBarExtraContent">
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" size="mini" status="primary" @click="refresh"/>
        <vxe-button :disabled="approveDisabled" :loading="approveLoading" content="button.approval" size="mini" status="primary" @click="approve"/>
        <vxe-button :disabled="rejectDisabled" :loading="rejectLoading" content="button.reject" size="mini" status="danger" @click="reject"/>
      </a-space>
    </a-tabs>
  </a-layout>
</template>

<script>
import { findEnum } from '@/api/Api'
import CountingApproveTable from '@/views/counting/counting_approve/CountingApproveTable.vue'
import CountingApproveDetail from '@/views/counting/counting_approve/CountingApproveDetail.vue'

export default {
  name: 'TemporaryCounting',
  components: {
    CountingApproveDetail,
    CountingApproveTable
  },
  data() {
    return {
      activeKey: '1',
      orderStatus: [],
      countingTypes: [],
      approveLoading: false,
      rejectLoading: false,
      approveDisabled: false,
      rejectDisabled: false
    }
  },
  watch: {
    activeKey: {
      handler(newVal) {
        if (newVal === '1') {
          this.approveDisabled = false
          this.rejectDisabled = false
        } else {
          this.approveDisabled = true
          this.rejectDisabled = true
        }
      }
    }
  },
  mounted() {
    findEnum('OrderStatus').then(res => {
      if (res.success) {
        this.orderStatus = res.result
      }
    })
    findEnum('CountingType').then(res => {
      if (res.success) {
        this.countingTypes = res.result
      }
    })
  },
  methods: {
    dblclick(record) {
      this.activeKey = '2'
      this.$refs.countingApproveDetail.refresh(record)
    },
    approve() {
      this.approveLoading = true
      this.$refs.countingApproveTable.approve()
    },
    reject() {
      this.rejectLoading = true
      this.$refs.countingApproveTable.reject()
    },
    refresh() {
      if (this.activeKey === '1') {
        this.$refs.countingApproveTable.refresh()
      } else {
        this.$refs.countingApproveDetail.refresh()
      }
    },
    success() {
      this.approveLoading = false
      this.rejectLoading = false
      this.$refs.countingApproveTable.refresh()
      this.$refs.countingApproveDetail.clear()
    },
    fail() {
      this.approveLoading = false
      this.rejectLoading = false
    }
  }
}
</script>